import { AppBar, Box, Toolbar } from '@mui/material';
import { HeaderLogin } from '../HeaderLogin';
import WarningIcon from '@mui/icons-material/Warning';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { AppState } from 'store';
import logo from '../../assets/logo.png';

function Header() {
  const { t } = useTranslation();
  const configuration = useSelector((state: AppState) => state.configuration);
  const config = configuration.configurations.find(
    (config) => config.configurationId === configuration.configurationId
  );

  return (
    <AppBar position="static" className="headerStyle root">
      <Toolbar className="toolbar">
        <Box
          className="toolbarSection"
          component="img"
          alt="Philips logo."
          src={logo}
        />
        {!config?.isProductActive && configuration?.configurationId && (
          <div className="rowFlex temp-warning-message">
            <span className="colFlex warning-icon">
              <WarningIcon className="warning-size" />
            </span>
            &nbsp;
            <div className="warning-message">
              <h2 className="m-0"> {t('label.inActiveProduct')}</h2>
            </div>
          </div>
        )}
        <Box>
          <HeaderLogin />
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
